<template>
  <error :type="'failure'"
         :link="{href: this.calendarUrl, remote: false, text: 'Go to Calendar'}"
         :message='"This course can no longer be booked into."'></error>
</template>

<script>
  import Error from '../../tdesk_notice';

  export default {
    props: {
      courseTypeId: {
        type: Number,
        required: true
      },
      calendarUrl: {
        required: true,
        type: String
      }
    },
    components: {Error}
  };
</script>